/**
 * Popup functionality
 */
(function () {
  // DOM elements
  if (!document.querySelector(".popup")) return;
  const popupOverlay = document.getElementById("popup-overlay");
  const pageId = document.querySelector(".popup").getAttribute("data-popup-id");
  const body = document.querySelector("body");
  // Cookie functions
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? match[2] : null;
  }

  // Show popup
  function showPopup() {
    if (!popupOverlay) return;

    // Check if user has accepted GDPR
    if (getCookie(`gdpr_${pageId}_accepted`)) {
      setTimeout(() => {
        hidePopup();
      }, 20000);
      return;
    }

    // Add active class
    popupOverlay.classList.add("is-active");
    // body.style.overflow = 'unset';
  }

  // Hide popup
  function hidePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove("is-active");
    // body.style.overflow = 'auto';
  }

  // Event listeners
  function initPopup() {
    if (!popupOverlay) return;

    // Show popup on page load
    showPopup();
  }

  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", initPopup);
})();
